import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LINKS_SYSTEMS_RESET } from '../../../redux/constantes/linksSystem';
import { CreateLinksSystemsAction, SearchLinksSystemsAction } from '../../../redux/actions/linksSystem';

import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import { ContainerForm } from '../../../components/Containers';
import { WrapperButtons } from '../../../components/WrapperButtons';
import { WrapperLinks } from '../../../components/LinksSystem/WrapperLinks';
import InputLinks from '../../../components/LinksSystem/InputLinks';
import LinksSystemOption from '../../../components/LinksSystem/LinksSystemOption';
import ButtonSend from '../../../components/ButtonSend';
import ButtonBack from '../../../components/ButtonBack';
import HeaderTitle from '../../../components/HeaderTitle';
import SubTitleWrapper from '../../../components/SubTitleWrapper';

export default function TemplateCreateLinksSystem() {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [company, setCompany] = useState('');
  const [description, setDescription] = useState('');

  const { success: successCreateLinksSystem, error: errorCreateLinksSystem } = useSelector(
    (state) => state.createLinksSystem,
  );
  const { linksSystem: searchLinksSystem, error: searchLinksSystemError } = useSelector(
    (state) => state.searchLinksSystem,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchLinksSystemError === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [searchLinksSystemError]);

  useEffect(() => {
    dispatch(SearchLinksSystemsAction());
  }, [dispatch]);

  useEffect(() => {
    if (successCreateLinksSystem) {
      setTimeout(() => {
        dispatch({ type: LINKS_SYSTEMS_RESET });
        document.location.href = '/registro-links-sistema';
      }, 3000);
    }
    if (errorCreateLinksSystem) {
      setTimeout(() => {
        dispatch({ type: LINKS_SYSTEMS_RESET });
      }, 3000);
    }
  }, [dispatch, successCreateLinksSystem, errorCreateLinksSystem]);

  const handleSubmit = () => {
    dispatch(CreateLinksSystemsAction(name, url, company, description));
  };

  return (
    <ContainerForm>
      <HeaderTitle text="Cadastrar Novos Links do Sistema" linkIcon="/images/icons/links.svg" />
      <InputLinks
        id="name"
        label="Nome do Link"
        type="text"
        onChange={(e) => setName(e.target.value)}
        value={name}
        placeholder="Exemplo: Google"
      />
      <InputLinks
        id="url"
        label="URL do Link"
        type="text"
        onChange={(e) => setUrl(e.target.value)}
        value={url}
        placeholder="Exemplo: https://google.com"
      />
      <InputLinks
        id="company"
        label="Empresa"
        type="text"
        onChange={(e) => setCompany(e.target.value)}
        value={company}
        placeholder="Exemplo: Google"
      />
      <InputLinks
        id="description"
        label="Descrição"
        type="text"
        onChange={(e) => setDescription(e.target.value)}
        value={description}
        placeholder="Exemplo: esse links direciona para o site do google"
      />
      <WrapperButtons>
        <ButtonBack />
        <ButtonSend onClick={handleSubmit}>Cadastrar</ButtonSend>
      </WrapperButtons>
      <div>
        <SubTitleWrapper subTitle="Links Cadastrados" />
        <WrapperLinks>
          {searchLinksSystem &&
            searchLinksSystem.map((link, index) => <LinksSystemOption key={index + 1} link={link} />)}
        </WrapperLinks>
      </div>
      {errorCreateLinksSystem && <MessageBoxError>{errorCreateLinksSystem}</MessageBoxError>}
      {successCreateLinksSystem && <MessageBoxSuccess>Link cadastrado com sucesso!</MessageBoxSuccess>}
    </ContainerForm>
  );
}
